export const LeaseType = {
  fixedTerm: 901029,
  na: 901030,
  periodic: 901032
} as const;
export type LeaseTypeCodes = (typeof LeaseType)[keyof typeof LeaseType];
export type LeaseTypeType = keyof typeof LeaseType;
